
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["getStores"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "built-[1].a5960aa839b4989b0e17.worker.js", { name: "built-[1].[contenthash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "built-[1].a5960aa839b4989b0e17.worker.js");
					addMethods(w, methods)
					
					return w
				}
			